import { jitsiLocalStorage } from '@jitsi/js-utils';
import { JIBRI_STATUS_URL } from '../../native/constants';
import { sendFormData } from '../../native/functions';

export function updateStatusQueue(streamId) {
    return (dispatch, getState) => {
        const type = 'record';
        const status = streamId ? 'on' : 'off';

        if (navigator.product !== 'ReactNative') {
            APP.WildixAPI.Recording.updateStatusQueue(streamId, type, status);

            return;
        }

        const { userToken, room } = getState()['features/base/settings'];

        const userFullJid = jitsiLocalStorage.getItem('xmpp_username_override');
        const data = {
            type,
            status,
            username: userFullJid?.split('@')[0],
            resource: userFullJid?.split('/')[1],
            'room_token': room,
            'stream_key': streamId
        };

        return sendFormData({ url: JIBRI_STATUS_URL,
            data,
            token: userToken });
    };
}
